import React from 'react';
import {Box, Grid} from "@mui/material";
import {AlfyButton} from "../AlfyButton";
import {AlfyBorderButton} from "../AlfyBorderButton";
import {useNavigate} from "react-router-dom";
import {useKakao} from "../../hooks/kakaoHooks";
import {useFetchAppointmentWithPoll} from "../../states/appointment/server";
import {useFetchMemberMe} from "../../states/member/server";

export interface AppointmentOverviewBottomButtonsProps {
    appointmentId: string;
    isVoted?: boolean;
}

/**
 * 나도 날짜 고르기: 로그인 안했거나 투표 데이터가 전혀 없는 경우
 * 톡으로 공유하기 & 다시 투표하기: 로그인 했고 투표 데이터가 있는 경우
 */
export const AppointmentOverviewBottomButtons: React.FC<AppointmentOverviewBottomButtonsProps> = ({ appointmentId }) => {
    const navigate = useNavigate();
    const { data: appointment } = useFetchAppointmentWithPoll(appointmentId)
    const { data: memberMe } = useFetchMemberMe(appointmentId)
    const { inviteByKakao } = useKakao()

    const handleClick = (path: string) => {
        navigate(path);
    }

    return (
        <>
            <Box textAlign={"center"} marginTop={'20px'}>
                <span className={"description-text"} style={{fontSize: '16px'}}>약속 현황을 톡으로 공유해보세요!</span>
            </Box>
            <Box marginTop={'20px'} paddingBottom={'40px'}>
                {!memberMe &&
                    <AlfyButton text={'나도 날짜 고르기'} onClick={() => handleClick(`/appointments/${appointmentId}/poll`)} />
                }
                {memberMe &&
                    <Grid container spacing={1}>
                        <Grid item xs>
                            <AlfyButton text={'톡으로 공유하기'} onClick={() => inviteByKakao(appointment!)} />
                        </Grid>
                        <Grid item xs>
                            <AlfyBorderButton text={'다시 투표하기'} onClick={() => handleClick(`/appointments/${appointmentId}/poll`)} />
                        </Grid>
                    </Grid>
                }
            </Box>
        </>
    )
}